import type { GetProductsResItem2ProductsItemDto } from '@travelity/api/generated';
import { Box, Chip, Paper, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PackageProductItem } from './components/PackageProductItem';

const PackageItemProducts = ({
    products,
}: {
    products: GetProductsResItem2ProductsItemDto[];
}) => {
    const { t } = useTranslation('package');

    return (
        <Paper
            sx={{
                alignItems: 'stretch',
                maxWidth: '95%',
                bgcolor: '#FFF',
            }}
        >
            {products.map(product => (
                <Stack key={product.day_index} gap={1} sx={{ p: 1 }}>
                    <Box sx={{ my: 1 }}>
                        <Chip
                            label={t(`Day ${product.offset_days + 1}`)}
                            sx={{
                                bgcolor: '#D9F7F1',
                                color: '#0B6B5E',
                                fontWeight: 800,
                                px: 1,
                                borderRadius: 999,
                                height: 36,
                            }}
                        />
                    </Box>
                    <Stack gap={2}>
                        {product.items.map(
                            ({ ref, start_time, pricing, schedule }) => (
                                <PackageProductItem
                                    key={ref.id}
                                    productId={ref.id}
                                    productName={ref.name}
                                    productType={ref.type}
                                    startTime={start_time}
                                    pricingItems={pricing?.items}
                                    schedules={schedule?.items}
                                />
                            )
                        )}
                    </Stack>
                </Stack>
            ))}
        </Paper>
    );
};

export default PackageItemProducts;
